export type Role = 'PM' | 'DL'; // 设总 | 专负
export type Discipline = '建筑' | '暖通' | '结构';
export type TimesheetType = '设计工时' | '对外沟通工时' | '差旅交通工时';
export type Status = '待审批' | '已通过' | '已打回';

export interface Employee {
    id: string;
    name: string;
    discipline: Discipline;
    avatar: string;
}

export interface TimesheetEntry {
    id: string;
    projectId: string;
    projectName: string;
    employee: Employee;
    date: string;
    type: TimesheetType;
    hours: number;
    description: string;
    status: Status;
    rejectReason?: string;
}

export function getWeekStart(dateStr: string): Date {
    const d = new Date(dateStr);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);
    const start = new Date(d.setDate(diff));
    start.setHours(0, 0, 0, 0);
    return start;
}

export function formatDate(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
}

export function addDays(date: Date, days: number): Date {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
}

export function getWeekRangeDisplay(startDate: Date): string {
    const endDate = addDays(startDate, 6);
    const fm = `${startDate.getFullYear()}年${startDate.getMonth() + 1}月${startDate.getDate()}日`;
    const tm = `${endDate.getMonth() + 1}月${endDate.getDate()}日`;
    if (startDate.getFullYear() !== endDate.getFullYear()) {
        return `${fm} - ${endDate.getFullYear()}年${tm}`;
    }
    return `${fm} - ${tm}`;
}
export function getWeekRangeDisplayByString(start: string, end: string): string {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const fm = `${startDate.getFullYear()}年${startDate.getMonth() + 1}月${startDate.getDate()}日`;
    const tm = `${endDate.getMonth() + 1}月${endDate.getDate()}日`;
    if (startDate.getFullYear() !== endDate.getFullYear()) {
        return `${fm} - ${endDate.getFullYear()}年${tm}`;
    }
    return `${fm} - ${tm}`;
}

const dayNames = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

export function getDayDisplay(dateStr: string): string {
    const d = new Date(dateStr);
    return `${dayNames[d.getDay()]} ${d.getMonth() + 1}/${d.getDate()}`;
}